<template>
    <div class="analysis-option flex">
        <div class="option-cont">
            <div class="cont-tit">选择前项</div>
            <div  class="cont-radio">
                <el-radio-group v-removeAriaHidden v-model="beforeRadio" @change='before_click'>
                    <div class="radio-list"  v-for="(item,index) in radioOption" :key="index+item.label">
                        <el-radio :label='item.label'>{{item.value}}</el-radio>
                    </div>
                </el-radio-group>
            </div>
            
        </div>
        <div class="option-cont">
            <div class="cont-tit">选择后项</div>
            <div  class="cont-radio">
                <el-radio-group v-removeAriaHidden v-model="afterRadio" @change='after_click'>
                    <div class="radio-list"  v-for="(item,index) in radioOption" :key="index+item.label">
                        <el-radio :label='item.label'>{{item.value}}</el-radio>
                    </div>
                </el-radio-group>
            </div>
        </div>
    </div>
</template>

<script>

import excavateData from './excavateData.js'
export default {
    data () {
        return {
            beforeRadio:'clinicalFeature',
            afterRadio:'clinicalFeature',
            radioOption:excavateData.radioOption
        }
    },
    methods: {
        before_click(val){
            let valName=''
            this.radioOption.forEach(item => {
                if(item.label==val){
                    valName= item.value; 
                }
            });
           this.$emit('option_click',{type:'before',val,valName} )
        },
        after_click(val){
             let valName=''
            this.radioOption.forEach(item => {
                if(item.label==val){
                    valName = item.value; 
                }
            });
           this.$emit('option_click',{type:'after',val,valName} )
        },
    }
}
</script>

<style>

</style>